
import Vue from 'vue';
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';
import Card from '@/components/Card/index.vue';
import HeaderInternal from '@/components/HeaderInternal/index.vue';
import Tag from '@/components/Tag/index.vue';
import Modal from '@/components/Modal/index.vue';
import getTerritoryByCarCodeService from '@/services/territory/get-territory-by-car-code';
import VueQRCodeComponent from 'vue-qrcode-component';
import { getPixTxId } from '@/services/pix/get-pix-txid';
import { getPix } from '@/services/pix/get-pix';
import getTerritoryByIdService from '@/services/territory/get-territory-by-id';
import getAct from '@/services/act/get-act';
import getTickets from '@/services/tickets/get-tickets';
import Accordion from '@/components/Accordion/index.vue';
import apiGixget from '@/services/appoinments/get-gix';
import getCalculateTicket from '@/services/tickets/get-tickets-total';
import { GetReportParms, getReport } from '@/services/territory/get-report';
import { capitalizeFirstLetter } from '@/utils/capitalize-first-letter';
import getTerritoryPenaltyStatus from '@/services/territory/get-territory-penalty-status';
import {
  TerritoryPenaltyStatus, TerritoryPenaltyStatusEnum,
} from '@/config/types';
import { getUserGroup } from '@/utils';
import constants from '@/config/constants';
import {
  Container, Main, Wrapper,
} from './styles';

Vue.component('qr-code', VueQRCodeComponent);

export default Vue.extend({
  props: ['id'],
  components: {
    Card,
    Container,
    HeaderInternal,
    Main,
    Tag,
    Accordion,
    Wrapper,
    Modal,
  },
  data() {
    return {
      isTicket: false,
      territoryEditionModal: false,
      visibleModal: true,
      amountAll: 0,
      paymentPayed: '',
      qrCodePix: '',
      lengthAct: 0,
      statusPix: '',
      txId: '',
      total: 0,
      territory: {
        loaded: false,
        territoryEditionModal: false,
        agents: [{
          id: '',
        }],
        city: '',
        force: '',
        name: '',
        car: '',
        id: '',
        documents: [],
      },
      qrCode: '',
      statusItem: '',
      month: 0,
      delayed: false,
      delayedDate: '',
      ticketName: '',
      actData: {} as any,
      dataTickets: {} as any,
      territoryPenaltyStatus: {} as TerritoryPenaltyStatus,
      gixData: {} as any,
      statusFlag: {} as TerritoryPenaltyStatus,
      linkActPdf: '',
      dataDue: '',
      allTickets: 0,
      userLoged: JSON.parse(sessionStorage.getItem('userLogged') as string),
      territoryArray: [] as any[],
      objAct: {} as any,
      dataCdTerritory: {
        cdTerritory: '',
      } as any,
      tickets: {} as any,
      headerColumns: ['Parcelamento', 'Data de Vencimento', 'Status'],
      territoryByCar: {
        loaded: false,
        aderiuPRA: '',
        area: '',
        dataAnalise: '',
        dataRegistro: '',
        dataRetificacao: '',
        latitude: '',
        longitude: '',
        modulosFiscais: '',
        statusImovel: '',
        condicaoAnalise: '',
        estado: '',
      },
      report: {
        type: 'termSocioEnvironmental',
      } as any,
    };
  },
  computed: {
    ...mapGetters(['DateById', 'DateAct']),
    getAppointment(): any[] {
      return this.territoryArray.map((appointment) => {
        const dateStart = moment(appointment.dtAppointment || appointment.createdOn);
        const dateEnd = appointment.dtAppointment
          ? moment(appointment.dtAppointment).add(7, 'days')
          : moment(appointment.act);

        return {
          type: appointment?.type?.type || 'ACT',
          dtAppointment: dateStart.format('L'),
          dtEnd: dateEnd.format('L'),
          status: appointment.status || 'Em andamento',
          result: 'Aprovado',
        };
      }).sort((date1, date2) => this.IsEqualDate(date1.dtAppointment, date2.dtAppointment));
    },
    getDocKey(): object {
      return {
        tercom: 'Termo de compromisso',
        termsocioenvironmental: 'Analise socioambiental',
      };
    },
    getDocs(): any[] {
      return [...this.territory.documents, this.report].map((doc) => {
        const docName = this.getDocKey[doc.type?.toLocaleLowerCase()];

        if (docName) {
          return {
            name: capitalizeFirstLetter(docName),
            url: doc.url || doc.urlExtract,
          };
        }
        return null;
      }).filter(Boolean);
    },
  },
  methods: {
    ...mapActions({ getAppointmentDate: 'getAppointmentDate' }),
    IsEqualDate(date1: string, date2: string) {
      return moment(date1, 'DD/MM/YYYY').unix() - moment(date2, 'DD/MM/YYYY').unix();
    },
    payPix(value) {
      this.territoryEditionModal = true;
      this.visibleModal = true;
      this.qrCode = value;
    },
    getPix() {
      getPixTxId(this.$route.params.id, this.userLoged.company.stKey).then((responseTxid) => {
        this.qrCodePix = responseTxid[0]?.qrCode;
        this.txId = responseTxid[0]?.txId;
        if (responseTxid.length > 0) {
          getPix(this.txId).then((respData) => {
            if (respData.status === 'CONCLUIDA' || this.isTicket) {
              this.statusPix = 'Pago';
            }
            if (respData.status === 'ATIVA' && !this.isTicket) {
              this.statusPix = 'Pendente de pagamento';
            }
          });
        }
      });
    },
    convertDataTicketsArray() {
      // Se há apenas uma parcela
      if (this.tickets.objectResult.length === 1) {
        const ticket = this.tickets.objectResult[0];
        ticket.dueDate = moment(ticket.dueDate).format('DD/MM/YYYY');
        if (ticket.status === 'payed') {
          this.isTicket = true;
          ticket.status = 'Pago';
        } else if (ticket.status === 'pending') {
          ticket.status = 'Pendente';
        } else if (ticket.status === 'cancelled') {
          ticket.status = 'Cancelado';
        }
      } else {
        let allPaid = true;

        for (let i = 0; i < this.tickets.objectResult.length; i += 1) {
          const ticket = this.tickets.objectResult[i];
          ticket.dueDate = moment(ticket.dueDate).format('DD/MM/YYYY');

          if (ticket.status === 'payed') {
            ticket.status = 'Pago';
          } else if (ticket.status === 'pending') {
            ticket.status = 'Pendente';
            allPaid = false;
          } else if (ticket.status === 'cancelled') {
            ticket.status = 'Cancelado';
            allPaid = false;
          }
        }
        if (allPaid) {
          this.isTicket = true;
        } else {
          this.isTicket = false;
        }
      }
    },
    async getActFunction() {
      this.actData = await getAct(this.userLoged.company.stKey, this.$route.params.id);
      this.lengthAct = this.actData.objectResult.length;
    },
    async getTerritoryById() {
      /* eslint max-len: ["error", { "code": 159 }] */
      const { id } = this.$route.params;

      const response = await getTerritoryByIdService(id);
      if (response.hasErrors) this.$router.push('/not-found');

      this.territory = response.objectResult;

      this.territory.loaded = true;

      if (this.isAdminUser()) {
        this.territoryPenaltyStatus = await this.getTerritoryPenaltyStatus(id);
      }

      let documentCAR;

      if (response.objectResult.documents) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.territory.documents.forEach((document: any, index) => {
          if (document.type === 'TERCOM') {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (this as any).territory.documents[index].title = document.title !== '' ? document.title : this.$t('terms');
          }
        });
        documentCAR = response.objectResult.documents.find(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (document: any) => document.type.includes('CARDOC'),
        );
      }

      if (documentCAR) {
        this.territory.car = documentCAR.title;
        this.getTerritoryByCarCode(this.territory.car);
      } else {
        this.territoryByCar.loaded = true;
      }
    },
    openPix() {
      this.$router.push(`/paypix/${this.$route.params.id}`);
    },
    close() {
      // @ts-ignore
      this.territoryEditionModal = false;
      this.visibleModal = false;
    },
    goToGeo(dataType: string, dataInitial: string, dataEnd: string) {
      if (dataType === 'Geomonitoramento') {
        this.$router.push({ name: 'Geomonitoramento', params: { dataStart: dataInitial, dataEnd } });
        return;
      }

      if (dataType === 'Autovistoria') {
        this.$router.push({ name: 'Autovistoria', params: { dataStart: dataInitial, dataEnd } });
      }
    },
    goToPenaltyPage() {
      this.$router.push({ name: 'Penalty', params: { id: this.territory.id, name: this.territory.name }, append: false });
    },
    async getTerritoryByCarCode(carCode: string) {
      const { objectResult } = await getTerritoryByCarCodeService(carCode);

      if (objectResult) this.territoryByCar = objectResult.dadosExtratoPdf;

      this.territoryByCar.loaded = true;
    },
    async verifyPenalty() {
      const { id } = this.$route.params;
      this.statusFlag = await this.getTerritoryPenaltyStatus(id);
    },
    getReportRequest() {
      const params: GetReportParms = {
        cdUser: this.userLoged.idUser,
        tokenKey: this.userLoged.company.stKey,
        cdTerritory: this.$route.params.id,
      };
      getReport(params).then((data) => { this.report = { ...this.report, ...data }; });
    },
    isAdminUser() {
      return getUserGroup() === constants.roles.admin;
    },
    getTerritoryPenaltyStatus(territoryId: string) {
      return getTerritoryPenaltyStatus(territoryId);
    },
    displayPenaltyPageButton() {
      return this.isAdminUser() && this.territoryPenaltyStatus.id === TerritoryPenaltyStatusEnum.pending;
    },
    ticketGet() {
      getCalculateTicket({ cdTerritory: this.$route.params.id });
      getCalculateTicket({ cdTerritory: this.$route.params.id })
        .then((data) => {
          this.dataTickets = data.objectResult;
          this.allTickets = this.dataTickets.length;
          this.statusItem = this.dataTickets[0].statusItem;
          this.paymentPayed = this.dataTickets[0].paymentPayed;
          const dateNow = new Date();
          const formated = moment(dateNow).format('YYYY-MM-DD');
          this.dataTickets.forEach((e) => {
            if (formated < e.dueDate && e.status === 'pending') {
              this.dataDue = e.dueDate;
              this.dataDue = moment(this.dataDue).format('DD-MM-YYYY');
            } else if (formated > e.dueDate && e.status === 'pending') {
              this.dataDue = e.dueDate;
              this.ticketName = e.ticketName;
              this.delayedDate = moment(this.dataDue).format('DD/MM/YYYY');
              this.delayed = true;
            }
          });
          // @ts-ignore
          if (this.dataTickets[0].paymentPayed === '0') {
            // @ts-ignore
            this.amountAll = this.dataTickets[0].totalAmount;
            // @ts-ignore
            this.txId = this.dataTickets[0].txId;
          } else {
            // @ts-ignore
            this.total = parseFloat(this.dataTickets.length) - parseFloat(this.dataTickets[0].paymentPayed);
            // @ts-ignore
            this.amountAll = this.dataTickets[0].amount * this.total;
            // @ts-ignore
            console.log(this.dataTickets[0].txId);
            // @ts-ignore
            this.txId = this.dataTickets[0].txId;
            this.getStepDate.isLoadingPayment = false;
          }
        })
        .catch(() => {
          this.resetStepsRegisterTerritory();
          this.getStepDate.isErrors = true;
        });
    },
  },
  async created() {
    this.getActFunction();
    await this.getTerritoryById();
    this.ticketGet();
    const { idUser } = JSON.parse(sessionStorage.getItem('userLogged') || '{}');
    const { company } = JSON.parse(sessionStorage.getItem('userLogged') || '{}');
    const bearer = sessionStorage.getItem('chave') || '{}';
    const stKey = this.userLoged.company.stKey.toString();
    this.gixData = apiGixget(idUser, bearer, stKey);
    this.dataCdTerritory.cdTerritory = this.territory.id;
    this.actData = await getAct(company.stKey, this.territory.id);
    this.tickets = await getTickets({ cdTerritory: this.territory.id });
    this.convertDataTicketsArray();
    this.getPix();
    this.gixData.then((e) => {
      this.objAct = e.data.objectResult;
    });
    this.verifyPenalty();
    // New Realease new
  },
});
